// Flow.js - Defines the "flow" enumerations.

// HelpBot modules;
import Enum from './Enum';

export const FLOW = Enum(
   {
      GOOD : 'good',
      FAIL : 'fail',
      WARN : 'warn',
   }
); // FLOW;
